<script>
    import store from '@/utils/store';
    import apiHelper from '@/utils/apiHelpers';
    import { mapState } from 'vuex';
    import Alert from '@/components/common/alert/AlertView';

    export default {
        name: 'login-component',
        data() {
            return {
                showPassword: false,
                isVerifyOTP: false,
                alert: {
                    visible: false,
                    type: '',
                    message: ''
                },
                data: {
                    account_id: '',
                    user_name: '',
                    password: '',
					phoneNum: '',
					otp_code: '',
					otpResult: ''
                },
				logoOnlySrc: require('../../assets/img/logo-only.png'),
            };
        },
        components: {
            Alert,
        },
        computed: {
            ...mapState([
				'jwtToken',
			]),
            passwordFieldType() {
                return this.showPassword ? 'text' : 'password';
            },
            eyeIcon() {
                return this.showPassword ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash';
            },
        },
        methods: {
            async login() {
                try {
                    const response = await apiHelper.post('/login', this.data, this.$router);
                    if (response.success) {
                        // this.sendOTP(response.phoneNum);
						// this.data.phoneNum = response.phoneNum;
						// this.isVerifyOTP = true;
                        this.getLoggedUser(response.token);
                    } else {
                        throw new Error('Unsuccessful response');
                    }
                } catch (error) {
                    if (error.response && error.response.data && 
						(error.response.data.message === 'Invalid data' || 
						error.response.data.message === 'User does not exist')) {
                        this.$refs.alert.showAlert('danger', error.response.data.message);
                    } else {
                        this.$refs.alert.showAlert('danger', 'Something went wrong. Please contact support.');
                    }
                }
            },
            async getLoggedUser(token){
                const response = await apiHelper.post('/user/logged', token, this.$router);
                if (response.success) {
                    store.commit('setJWTToken', token);
                    store.commit('setIsLoggedIn', true);
                    store.commit('setLoggedUser', response.user);
                    store.commit('setToggleAsideMenu', false); //not collapsed
                    store.commit('setToggleDarkMode', response.user.is_app_dark_mode);
                    this.$router.push('/dashboard');
                } else {
                    this.$refs.alert.showAlert('danger', 'Something went wrong. Please contact support.');
                    throw new Error('Unsuccessful response');
                }
            },
            integersOnly(event){
				const cleaned = event.target.value.replace(/\D/g, '');
				event.target.value = cleaned;
				this.data.otp_code = cleaned;
            },
            backToLogin(){
                this.isVerifyOTP = !this.isVerifyOTP;
            },
            async sendOTP(phoneNum){
                const response = await apiHelper.post('/sms/otp', phoneNum, this.$router);
                try {
                    if (response.success) {
						this.data.otpResult = response.otpResult;
                    } else {
                        throw new Error('Unsuccessful response');
                    }
                } catch (error) {
					this.$refs.alert.showAlert('danger', 'Something went wrong. Please contact support.');
					console.log('Login error:', error)
                }
            },
			async resendOTP(){
				this.sendOTP(this.data.phoneNum);
            },
            async verifyOTP(){
                if(this.data.otp_code){
					const response = await apiHelper.post('/sms/verify', this.data, this.$router);
					try {
						if (response.success) {
							this.$refs.alert.showAlert('success', 'OTP sucessfully verified!');
							this.getLoggedUser(response.token);
							this.isVerifyOTP = !this.isVerifyOTP;
						} 
					} catch (error) {
						console.log(error)
						if(error.response.data){
							this.$refs.alert.showAlert('danger', error.response.data.message);
						}else{
							console.log('Login error:', error)
							this.$refs.alert.showAlert('danger', 'Something went wrong. Please contact support.');
						}
					}
                }
            },
            togglePasswordVisibility() {
                this.showPassword = !this.showPassword;
            },
        },
    }
</script>